import validate from "/var/www/frontend_build/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.24_db0@0.3.4_esli_use47k75taj4y6vnoejk7oouzq/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/frontend_build/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.24_db0@0.3.4_esli_use47k75taj4y6vnoejk7oouzq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/frontend_build/.app/middleware/auth.ts")
}